export default __webpack_public_path__ + "static/media/homerIcon.325aeeee.svg";